// extracted by mini-css-extract-plugin
export default {"tooltipRoot":"overschedule_tooltip-module___tooltipRoot___d039b39f","tooltipHeader":"overschedule_tooltip-module___tooltipHeader___b12cbb03"};